import React from "react";
import { withPreloadedJSON } from "@wss/hypernova";
import { createRoot } from "@wss/react";
import { initSentry } from "@wss/error-tracking/sentry";
import { logErrorBoundaryToSentry, PageFallback, ErrorBoundary } from "@wss/error-tracking/error-boundary";
import App from "~/App";
import { Header } from "~/common/Header/index.client";
import { Footer } from "~/common/Footer/index.client";
import PhotoGridCategory from "./index";
import { BranchCategoryDetail } from "~/common/Store/models/Category";
import "~/fonts/fontello/css/fontello-top.less";
import "~/less/_critical/include.less";
import "~/less/_critical/category-photo-grid.less";
import "~/less/_critical/product.less";

/** Enable hot reloading */
module.hot?.accept();
initSentry("Category Page - Photo Grid Template");
function PhotoGridCategoryPage(props: BranchCategoryDetail): JSX.Element {
  return <ErrorBoundary fallback={<PageFallback />} onError={logErrorBoundaryToSentry} data-sentry-element="ErrorBoundary" data-sentry-component="PhotoGridCategoryPage" data-sentry-source-file="index.client.tsx">
      <PhotoGridCategory {...props} data-sentry-element="PhotoGridCategory" data-sentry-source-file="index.client.tsx" />
    </ErrorBoundary>;
}
const PhotoGridCategoryPageWithData = withPreloadedJSON(PhotoGridCategoryPage, "CategoryPagePhotoGridTemplate");
const root = createRoot(document.querySelector("#root"));
root.render(<App>
    <Header />
    <PhotoGridCategoryPageWithData />
    <Footer />
  </App>);
if (document.querySelector("[data-component=carousel]")) {
  import("~/common/initCategoryCarousels").then(({
    default: initCategoryCarousels
  }) => initCategoryCarousels());
}